import { useState, type PropsWithChildren } from 'react'

import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from '@/components/ui'
import { ScrollArea } from '@/components/ui/scroll-area'
import {
  FluxoPagamentoMap,
  type IFluxoPagamento,
} from '@/features/simulador/services/get-fluxo-pagamentos-simulacao.service'

export interface IFluxoPagamentoProps {
  dados?: IFluxoPagamento[]
  calcularDados?: () => IFluxoPagamento[]
  titulo: string
}

export function FluxoPagamentoSheet({
  dados,
  calcularDados,
  titulo,
  children,
}: PropsWithChildren<IFluxoPagamentoProps>) {
  const [dadosCalculados, setDadosCalculados] = useState<IFluxoPagamento[]>([])

  const handleOpenChange = (open: boolean) => {
    if (open && calcularDados) {
      setDadosCalculados(calcularDados())
    }
  }

  const dadosParaRenderizar = dados ?? dadosCalculados

  return (
    <Sheet onOpenChange={handleOpenChange}>
      <SheetTrigger asChild>{children}</SheetTrigger>
      <SheetContent className="w-full bg-white px-6" aria-describedby={undefined}>
        <SheetHeader className="p-0">
          <SheetTitle className="font-nunito mt-18 p-0 text-sm font-semibold text-neutral-700">{titulo}</SheetTitle>
        </SheetHeader>
        <ScrollArea className="h-[calc(100svh-120px)]" aria-describedby={undefined}>
          <div className="mt-2 space-y-6 pr-13">
            {dadosParaRenderizar?.map((anoData) => (
              <div key={anoData.ano} className="space-y-4">
                <h3 className="text-base font-semibold text-neutral-600">{anoData.ano}</h3>
                <div className="space-y-3">
                  {anoData.parcelas.map((parcela, index) => (
                    <div key={`${anoData.ano}-${index}`}>
                      <div className="font-nunito flex items-start justify-between gap-9 text-sm">
                        <div className="flex items-start gap-3">
                          <span className="text-sm font-semibold text-neutral-700">{parcela.data}</span>
                          <span className="text-sm text-neutral-600">{FluxoPagamentoMap[parcela.tipoDaParcela]}</span>
                        </div>
                        <span className="text-sm whitespace-nowrap text-neutral-700">{parcela.valor}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </ScrollArea>
      </SheetContent>
    </Sheet>
  )
}
